import _slicedToArray from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _createClass from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _classCallCheck from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _regeneratorRuntime from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import { isHexString } from './index.js';
function walletConnect() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    version: 1
  };
  var _ref = options || {},
    _ref$bridge = _ref.bridge,
    bridge = _ref$bridge === void 0 ? 'https://bridge.walletconnect.org' : _ref$bridge,
    qrcodeModalOptions = _ref.qrcodeModalOptions,
    connectFirstChainId = _ref.connectFirstChainId,
    handleUri = _ref.handleUri;
  return function () {
    return {
      label: 'WalletConnect',
      getIcon: function () {
        var _getIcon = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
          return _regeneratorRuntime().wrap(function _callee$(_context) {
            while (1) switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return import('./icon.js');
              case 2:
                return _context.abrupt("return", _context.sent.default);
              case 3:
              case "end":
                return _context.stop();
            }
          }, _callee);
        }));
        function getIcon() {
          return _getIcon.apply(this, arguments);
        }
        return getIcon;
      }(),
      getInterface: function () {
        var _getInterface = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(_ref2) {
          var chains, EventEmitter, _yield$import, StaticJsonRpcProvider, _yield$import2, ProviderRpcError, ProviderRpcErrorCode, _yield$import3, WalletConnect, QRCodeModal, _yield$import4, Subject, fromEvent, _yield$import5, takeUntil, take, connector, emitter, EthProvider;
          return _regeneratorRuntime().wrap(function _callee3$(_context3) {
            while (1) switch (_context3.prev = _context3.next) {
              case 0:
                chains = _ref2.chains, EventEmitter = _ref2.EventEmitter;
                _context3.next = 3;
                return import('@ethersproject/providers');
              case 3:
                _yield$import = _context3.sent;
                StaticJsonRpcProvider = _yield$import.StaticJsonRpcProvider;
                _context3.next = 7;
                return import('@web3-onboard/common');
              case 7:
                _yield$import2 = _context3.sent;
                ProviderRpcError = _yield$import2.ProviderRpcError;
                ProviderRpcErrorCode = _yield$import2.ProviderRpcErrorCode;
                _context3.next = 12;
                return import('@walletconnect/client');
              case 12:
                _yield$import3 = _context3.sent;
                WalletConnect = _yield$import3.default;
                _context3.next = 16;
                return import('@walletconnect/qrcode-modal');
              case 16:
                QRCodeModal = _context3.sent;
                // @ts-ignore - TS thinks that there is no default property on the `QRCodeModal` but sometimes there is
                QRCodeModal = QRCodeModal.default || QRCodeModal;
                _context3.next = 20;
                return import('rxjs');
              case 20:
                _yield$import4 = _context3.sent;
                Subject = _yield$import4.Subject;
                fromEvent = _yield$import4.fromEvent;
                _context3.next = 25;
                return import('rxjs/operators');
              case 25:
                _yield$import5 = _context3.sent;
                takeUntil = _yield$import5.takeUntil;
                take = _yield$import5.take;
                connector = new WalletConnect({
                  bridge: bridge
                });
                if (!handleUri) {
                  _context3.next = 38;
                  break;
                }
                _context3.prev = 30;
                _context3.next = 33;
                return handleUri(connector.uri || '');
              case 33:
                _context3.next = 38;
                break;
              case 35:
                _context3.prev = 35;
                _context3.t0 = _context3["catch"](30);
                throw "An error occurred when handling the URI. Error: ".concat(_context3.t0);
              case 38:
                emitter = new EventEmitter();
                EthProvider = /*#__PURE__*/_createClass(function EthProvider(_ref3) {
                  var _this = this;
                  var connector = _ref3.connector,
                    chains = _ref3.chains;
                  _classCallCheck(this, EthProvider);
                  this.emit = emitter.emit.bind(emitter);
                  this.on = emitter.on.bind(emitter);
                  this.removeListener = emitter.removeListener.bind(emitter);
                  this.connector = connector;
                  this.chains = chains;
                  this.disconnected$ = new Subject();
                  this.providers = {};
                  // listen for session updates
                  fromEvent(this.connector, 'session_update', function (error, payload) {
                    if (error) {
                      throw error;
                    }
                    return payload;
                  }).pipe(takeUntil(this.disconnected$)).subscribe({
                    next: function next(_ref4) {
                      var params = _ref4.params;
                      var _params = _slicedToArray(params, 1),
                        _params$ = _params[0],
                        accounts = _params$.accounts,
                        chainId = _params$.chainId;
                      _this.emit('accountsChanged', accounts);
                      var hexChainId = isHexString(chainId) ? chainId : "0x".concat(chainId.toString(16));
                      _this.emit('chainChanged', hexChainId);
                    },
                    error: console.warn
                  });
                  // listen for disconnect event
                  fromEvent(this.connector, 'disconnect', function (error, payload) {
                    if (error) {
                      throw error;
                    }
                    return payload;
                  }).pipe(takeUntil(this.disconnected$)).subscribe({
                    next: function next() {
                      _this.emit('accountsChanged', []);
                      _this.disconnected$.next(true);
                      typeof localStorage !== 'undefined' && localStorage.removeItem('walletconnect');
                    },
                    error: console.warn
                  });
                  this.disconnect = function () {
                    return _this.connector.killSession();
                  };
                  this.request = /*#__PURE__*/function () {
                    var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(_ref5) {
                      var method, params, chainIdObj, chainId, currentChain;
                      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
                        while (1) switch (_context2.prev = _context2.next) {
                          case 0:
                            method = _ref5.method, params = _ref5.params;
                            if (!(method === 'eth_chainId')) {
                              _context2.next = 3;
                              break;
                            }
                            return _context2.abrupt("return", isHexString(_this.connector.chainId) ? _this.connector.chainId : "0x".concat(_this.connector.chainId.toString(16)));
                          case 3:
                            if (!(method === 'eth_requestAccounts')) {
                              _context2.next = 5;
                              break;
                            }
                            return _context2.abrupt("return", new Promise(function (resolve, reject) {
                              // Check if connection is already established
                              if (!_this.connector.connected) {
                                // create new session
                                _this.connector.createSession(connectFirstChainId ? {
                                  chainId: parseInt(chains[0].id, 16)
                                } : undefined).then(function () {
                                  QRCodeModal.open(_this.connector.uri, function () {
                                    return reject(new ProviderRpcError({
                                      code: 4001,
                                      message: 'User rejected the request.'
                                    }));
                                  }, qrcodeModalOptions);
                                });
                              } else {
                                var _this$connector$sessi = _this.connector.session,
                                  accounts = _this$connector$sessi.accounts,
                                  _chainId = _this$connector$sessi.chainId;
                                var hexChainId = isHexString(_chainId) ? _chainId : "0x".concat(_chainId.toString(16));
                                _this.emit('chainChanged', hexChainId);
                                return resolve(accounts);
                              }
                              // Subscribe to connection events
                              fromEvent(_this.connector, 'connect', function (error, payload) {
                                if (error) {
                                  throw error;
                                }
                                return payload;
                              }).pipe(take(1)).subscribe({
                                next: function next(_ref7) {
                                  var params = _ref7.params;
                                  var _params2 = _slicedToArray(params, 1),
                                    _params2$ = _params2[0],
                                    accounts = _params2$.accounts,
                                    chainId = _params2$.chainId;
                                  _this.emit('accountsChanged', accounts);
                                  var hexChainId = isHexString(chainId) ? chainId : "0x".concat(chainId.toString(16));
                                  _this.emit('chainChanged', hexChainId);
                                  QRCodeModal.close();
                                  resolve(accounts);
                                },
                                error: reject
                              });
                            }));
                          case 5:
                            if (!(method === 'eth_selectAccounts')) {
                              _context2.next = 7;
                              break;
                            }
                            throw new ProviderRpcError({
                              code: ProviderRpcErrorCode.UNSUPPORTED_METHOD,
                              message: "The Provider does not support the requested method: ".concat(method)
                            });
                          case 7:
                            if (!(method == 'wallet_switchEthereumChain')) {
                              _context2.next = 14;
                              break;
                            }
                            if (params) {
                              _context2.next = 10;
                              break;
                            }
                            throw new ProviderRpcError({
                              code: ProviderRpcErrorCode.INVALID_PARAMS,
                              message: "The Provider requires a chainId to be passed in as an argument"
                            });
                          case 10:
                            chainIdObj = params[0];
                            if (!(!chainIdObj.hasOwnProperty('chainId') || typeof chainIdObj['chainId'] === 'undefined')) {
                              _context2.next = 13;
                              break;
                            }
                            throw new ProviderRpcError({
                              code: ProviderRpcErrorCode.INVALID_PARAMS,
                              message: "The Provider requires a chainId to be passed in as an argument"
                            });
                          case 13:
                            return _context2.abrupt("return", _this.connector.sendCustomRequest({
                              method: 'wallet_switchEthereumChain',
                              params: [{
                                chainId: chainIdObj.chainId
                              }]
                            }));
                          case 14:
                            if (!(method === 'eth_sendTransaction')) {
                              _context2.next = 16;
                              break;
                            }
                            return _context2.abrupt("return", _this.connector.sendTransaction(params[0]));
                          case 16:
                            if (!(method === 'eth_signTransaction')) {
                              _context2.next = 18;
                              break;
                            }
                            return _context2.abrupt("return", _this.connector.signTransaction(params[0]));
                          case 18:
                            if (!(method === 'personal_sign')) {
                              _context2.next = 20;
                              break;
                            }
                            return _context2.abrupt("return", _this.connector.signPersonalMessage(params));
                          case 20:
                            if (!(method === 'eth_sign')) {
                              _context2.next = 22;
                              break;
                            }
                            return _context2.abrupt("return", _this.connector.signMessage(params));
                          case 22:
                            if (!method.includes('eth_signTypedData')) {
                              _context2.next = 24;
                              break;
                            }
                            return _context2.abrupt("return", _this.connector.signTypedData(params));
                          case 24:
                            if (!(method === 'eth_accounts')) {
                              _context2.next = 26;
                              break;
                            }
                            return _context2.abrupt("return", _this.connector.sendCustomRequest({
                              id: 1337,
                              jsonrpc: '2.0',
                              method: method,
                              params: params
                            }));
                          case 26:
                            _context2.next = 28;
                            return _this.request({
                              method: 'eth_chainId'
                            });
                          case 28:
                            chainId = _context2.sent;
                            if (_this.providers[chainId]) {
                              _context2.next = 34;
                              break;
                            }
                            currentChain = chains.find(function (_ref8) {
                              var id = _ref8.id;
                              return id === chainId;
                            });
                            if (currentChain) {
                              _context2.next = 33;
                              break;
                            }
                            throw new ProviderRpcError({
                              code: ProviderRpcErrorCode.CHAIN_NOT_ADDED,
                              message: "The Provider does not have a rpcUrl to make a request for the requested method: ".concat(method)
                            });
                          case 33:
                            _this.providers[chainId] = new StaticJsonRpcProvider(currentChain.rpcUrl);
                          case 34:
                            return _context2.abrupt("return", _this.providers[chainId].send(method,
                            // @ts-ignore
                            params));
                          case 35:
                          case "end":
                            return _context2.stop();
                        }
                      }, _callee2);
                    }));
                    return function (_x2) {
                      return _ref6.apply(this, arguments);
                    };
                  }();
                });
                return _context3.abrupt("return", {
                  provider: new EthProvider({
                    chains: chains,
                    connector: connector
                  })
                });
              case 41:
              case "end":
                return _context3.stop();
            }
          }, _callee3, null, [[30, 35]]);
        }));
        function getInterface(_x) {
          return _getInterface.apply(this, arguments);
        }
        return getInterface;
      }()
    };
  };
}
export default walletConnect;